
export const redemptionAttempMaster: Record<string, string> = {
  MULTIPLE_PER_DAY: 'Multiple Per Day',
  MULTIPLE_PER_PERIOD: 'Multiple Per Period'
};
